import api from '.';

const paymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createGeoLocation: builder.mutation({
      query: (params) => ({
        url: '/geo-location-points',
        method: 'POST',
        body: params
      }),
      transformResponse(res) {
        return res
      }
    }),

    updateGeoLocation: builder.mutation({
      
        query: (params) => ({
          url: `/geo-location-points/${params.id}`, // Include the user ID in the URL
          method: 'PATCH',
          body:  params.data
        }),
        
      }),
  })



});

export default paymentApi;
export const { useCreateGeoLocationMutation,useUpdateGeoLocationMutation } = paymentApi;
